
const CONFIG_PAGE_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-1",
            actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
        }
    },
    dialog: {
        actions: {
            cancelButton: "px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-xl transition-colors cursor-pointer",
            confirmButton: {
                base: "px-6 py-2 text-sm font-medium text-white rounded-xl transition-all shadow-sm flex items-center gap-2 cursor-pointer",
                active: "bg-[#7C3AED] hover:bg-[#6d28d9] shadow-[#7C3AED]/20",
                disabled: "bg-gray-300 cursor-not-allowed shadow-none"
            }
        },
        section: {
            label: "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2",
            input: "w-full rounded-xl bg-[#F9FAFB] border-gray-200 focus:border-[#7C3AED] focus:ring-0 hover:border-gray-300 transition-colors"
        }
    }
};

export default CONFIG_PAGE_DESIGN;
